import script from "./TheFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./TheFaq.vue?vue&type=script&setup=true&lang=js"

import "./TheFaq.vue?vue&type=style&index=0&id=59e8a906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e8a906"]])

export default __exports__